import Api from "shared/service/api/api";
import Helpers from "shared/service/helpers";
import { ACKNOWLEDGED_NPD_NOTIFICATION_STATE, ARCHIVED_NPD_NOTIFICATION_STATE } from "shared/service/consts";
import { vueInstance } from "@/main";

//actions
export const LOAD_COMMON = "loadCommon";
export const READ_ALERT = "readAlert";
export const SET_NOTIFICATION_NPD_STATE = "setNotificationNpdState";
export const LOAD_MENU = "loadMenu";

//mutations
export const SET_PROJECT_SERVICE_PAYMENT = "setProjectServicePayment";
export const SET_ALERTS = "setAlerts";
export const SET_READ_ALERT = "setReadAlert";
export const SET_READ_NOTIFICATION_NPD = "setReadNotificationNpd";
export const DELETE_NOTIFICATION_NPD = "deleteNotificationNpd";
export const SET_MENU = "setMenu";
export const SET_LOCAL_CATEGORIES = "setLocalCategories";
export const SET_HAS_NOTIFICATION = "setHasNotification";
export const SET_SHOW_CONSULTATION_OFFER_IN = "setShowConsultationOfferIn";
export const SET_MODERATION_RESULTS = "setModerationResults";
export const SHOW_RECEIPT_REQUIRED_MSG = "showReceiptRequiredMsg";
export const SET_TARIFF = "setFreeTariff";

const state = {
  alerts: {
    user: {
      data: [],
      countNew: null
    },
    npd: {
      data: [],
      countNew: null
    },
    totalNew: null,
    getCntMessage: function () {
      return Helpers.getWordCaseByNum(this.totalNew, {
        '1': 'новое',
        '2-3-4': 'новых',
      });
    },
  },
  projectServicePayment: {
    is_paid: true,
    date_end: null,
    invoice: {},
  },
  showConsultationOfferIn: null,
  moderationResults: null,
  menu: [],
  datasets: {
    localCategories: [],
  },
  hasNotification: false,
  isFree: true,
};

const getters = {
  projectServicePayment: (state) => state.projectServicePayment,
  localCategories: (state) => state.datasets.localCategories,
  hasNotification: (state) => state.hasNotification,
  isFree: (state) => state.isFree,
};

const actions = {
  [LOAD_COMMON]({ commit }) {
    return Api.account.common().then((response) => {
      commit(SET_PROJECT_SERVICE_PAYMENT, response.data.notification.project_service_payment);
      commit(SET_ALERTS, response.data.notification.alerts);
      commit(SET_SHOW_CONSULTATION_OFFER_IN, response.data.notification.show_consultation_offer_in);
      commit(SET_MODERATION_RESULTS, response.data.notification.moderation_results);
      commit(SHOW_RECEIPT_REQUIRED_MSG, response.data.notification.receipt_required_request);
      commit(SET_TARIFF, response.data.is_free);
      //commit(SET_TARIFF, true);

      response.data.item?.localCategories && commit(SET_LOCAL_CATEGORIES, response.data.item.localCategories);

      return response;
    });
  },
  [READ_ALERT]({ commit }, id) {
    return Api.account.alert
      .read(id)
      .then((response) => {
        response.success && commit(SET_READ_ALERT, id);
      })
      .catch((e) => e);
  },
  [SET_NOTIFICATION_NPD_STATE]({ commit }, {id, stateId}) {
    return Api.account.alert
      .setNotificationNpdState(id, stateId)
      .then((response) => {
        if (!response.success) {
          throw new Error(response.error);
        }
        stateId === ACKNOWLEDGED_NPD_NOTIFICATION_STATE && commit(SET_READ_NOTIFICATION_NPD, id);
        stateId === ARCHIVED_NPD_NOTIFICATION_STATE && commit(DELETE_NOTIFICATION_NPD, id);
      })
      .catch((e) => vueInstance.$alert.error("Ошибка изменения статуса уведомления"));
  },
  [LOAD_MENU]({ commit }) {
    Api.account
      .menu()
      .then((response) => {
        if (!response.success) {
          throw new Error(response.error);
        }

        commit(SET_MENU, response.data);
      })
      .catch((e) => vueInstance.$alert.error("Ошибка загрузки меню"));
  },
};

const mutations = {
  [SET_PROJECT_SERVICE_PAYMENT](state, value) {
    state.projectServicePayment = value;
  },
  [SET_ALERTS](state, alerts) {
    state.alerts.totalNew = 0;
    for (let key of ['user', 'npd']) {
      state.alerts[key].data = alerts[key].data;
      state.alerts[key].countNew = alerts[key].count_new;
      state.alerts.totalNew += state.alerts[key].countNew;
    }
  },
  [SET_SHOW_CONSULTATION_OFFER_IN](state, showConsultationOfferIn) {
    state.showConsultationOfferIn = showConsultationOfferIn;
  },
  [SET_MODERATION_RESULTS](state, moderationResults) {
    state.moderationResults = moderationResults;
  },
  // @todo: delete
  [SHOW_RECEIPT_REQUIRED_MSG](state, request) {
    if (request) {
      const balanceTypeIndex = request.balance_type_id - 1;
      const balanceTypes = ["продажного", "партнерского", "соавторского", "реферального"];
      const id = request.id;
      const type = balanceTypes[balanceTypeIndex];
      const sum = request.sum;
      Helpers.showReceiptRequiredMsg(id, {
        title: `Прикрепите, пожалуйста, ссылку на чек из кабинета "Мой Налог" на Ваш последний вывод #${id} с "${type}" счета на сумму ${sum} ₽ в данное окно`,
        html: "Пока ссылка на чек не будет отправлена, последующий вывод средств будет недоступен",
      });
    }
  },
  [SET_READ_ALERT](state, id) {
    const alert = state.alerts.user.data.find((a) => a.id === id);
    if (alert) {
      alert.read = true;
      state.alerts.user.countNew--;
      state.alerts.totalNew--;
    }
  },
  [SET_READ_NOTIFICATION_NPD](state, id) {
    const notification = state.alerts.npd.data.find((n) => n.id === id);
    if (notification) {
      notification.read = true;
      state.alerts.npd.countNew--;
      state.alerts.totalNew--;
    }
  },
  [DELETE_NOTIFICATION_NPD](state, id) {
    const index = state.alerts.npd.data.findIndex((n) => n.id === id);
    if (~index) {
      const { read } = state.alerts.npd.data.splice(index, 1)[0];
      if (!read) {
        state.alerts.npd.countNew--;
        state.alerts.totalNew--;
      }
    }
  },
  [SET_MENU](state, menu) {
    state.menu = menu;
  },
  [SET_LOCAL_CATEGORIES](state, localCategories) {
    state.datasets.localCategories = localCategories;
  },
  [SET_HAS_NOTIFICATION](state, flag) {
    state.hasNotification = flag;
  },
  [SET_TARIFF](state, isFree) {
    state.isFree = isFree;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
